import React from "react";
import styled from "styled-components";

export const SectionTitle = ({
  title,
  mobileOnly,
  hideOnMobile,
  centered,
  backdropText,
}) => {
  return (
    <Container mobileOnly={mobileOnly} hideOnMobile={hideOnMobile}>
      <CursiveTitleContainer>
        <CursiveTitle centered={centered}>
          {backdropText ? backdropText : title}
        </CursiveTitle>
      </CursiveTitleContainer>

      <MainTitle>{title}</MainTitle>
    </Container>
  );
};

const Container = styled.div`
  display: ${(props) => (props.mobileOnly ? "none" : "block")};
  margin-top: 3rem;
  width: 100%;
  margin-bottom: 4rem;

  @media screen and (max-width: 500px) {
    display: ${(props) => (props.hideOnMobile ? "none" : "block")};
  }
`;

const CursiveTitleContainer = styled.div`
  position: relative;
`;

const CursiveTitle = styled.h1`
  font-family: "Scriptina";
  font-weight: 200;
  font-size: 124px;
  letter-spacing: 10px;
  opacity: 0.2;
  position: absolute;
  margin: 0;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
  transform: translateY(-50%);

  @media screen and (max-width: 900px) {
    font-size: 64px;
    letter-spacing: 6px;
  }

  @media screen and (max-width: 600px) {
    font-size: 64px;
    letter-spacing: 4px;
    transform: translateY(-40%);
  }
`;

const MainTitle = styled.p`
  text-transform: uppercase;
  color: var(--color-bone);
  font-size: 36px;
  font-weight: 300;
  margin-top: 0;
  letter-spacing: 0.5em;
  text-align: center;
  width: 100%;

  @media screen and (max-width: 600px) {
    font-size: 24px;
    letter-spacing: 0.4em;
  }
`;
